import { AuthCard, AuthHeading, AuthFrame, Lockup } from "./AuthShared";

/* Terminal page for mobile viewports (OPSS-246): an accepted waitlist user who
 * opens the app on a phone is told to come back on a desktop rather than shown
 * a dashboard that doesn't fit. Rendered in place by router/MobileGuard, so it
 * covers the gated app only — the auth screens stay usable on mobile.
 * Presentational, no hooks. Sibling of ComingSoonScreen by design: same brand
 * frame, and below lg the split-screen's left panel is hidden, so the card here
 * carries the lockup itself. */

export function DesktopOnlyScreen() {
  return (
    <AuthFrame>
      <div className="onboarding onboarding-card w-full">
        <AuthCard>
          <div className="flex flex-col items-center gap-6 text-center">
            <Lockup tone="dark" />

            <div className="flex flex-col gap-1.5">
              <AuthHeading>Available on desktop only</AuthHeading>
              <p className="t-body-sm" style={{ color: "var(--fg-3)" }}>
                The AI21 Gateway is built for a desktop screen. Please open this
                page on your computer to set up your agents.
              </p>
            </div>
          </div>
        </AuthCard>
      </div>
    </AuthFrame>
  );
}
